const getters = {
  getBatchUnloads: (state) => {
    return _.toArray(state.batchUnload);
  },

}

export default getters